import { render, staticRenderFns } from "./ItemStepper.vue?vue&type=template&id=6523dd6e&scoped=true&"
import script from "./ItemStepper.vue?vue&type=script&lang=js&"
export * from "./ItemStepper.vue?vue&type=script&lang=js&"
import style0 from "./ItemStepper.vue?vue&type=style&index=0&id=6523dd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523dd6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VBtn,VCol,VRow})
